globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Public = appCustomerSpace.Modals.Public || {};

appCustomerSpace.Modals.Public.LastArticlesGivenList = (function(superClass) {
  utils.extend(LastArticlesGivenList, superClass);

  function LastArticlesGivenList($html) {
    return LastArticlesGivenList.__super__.constructor.apply(this, arguments);
  }

  $.extend(LastArticlesGivenList.prototype, {
    init: function() {
      LastArticlesGivenList.__super__.init.apply(this, arguments);
      SearchFilter.initFilters(this.$html.find('.input-filter'));
    },

    callbackSuccess: function(data) {
      if (data && data.response == 1) {
        $('#filters-resume').replaceWith(data.html);
        if (data.preview_html) {
          appCustomerSpace.currentController._reloadPreview(data.preview_html);
        }
        LastArticlesGivenList.__super__.callbackSuccess.apply(this, arguments);
      } else {
        LastArticlesGivenList.__super__.callbackSuccess.apply(this, arguments);
      }
    }
  });

  return LastArticlesGivenList;
})(appCustomerSpace.Modal);
